function dateCns() {
    // date festività
    const dateArray = ["2024-08-12","2024-08-13","2024-08-14","2024-08-15","2024-08-16","2024-08-17","2024-08-18","2024-08-19","2024-08-20","2024-08-21","2024-08-22","2024-08-23","2024-08-24","2024-08-25","2024-08-26","2024-08-27","2024-08-28"];

    // tempo base di consegna
    let tempbase = 72;
    // data corrente
    let today = new Date();
    let dataCorrente = today;

    function converter(dataIniziale) {
      const data = new Date(dataIniziale);

      const anno = data.getFullYear();
      const mese = (data.getMonth() + 1).toString().padStart(2, '0'); // Aggiungi uno zero iniziale se necessario
      const giorno = data.getDate().toString().padStart(2, '0');

      return `${anno}-${mese}-${giorno}`;
    }

    function calcolaWeekend(dataInizio, dataFine) {
      // oggetti Date 
      const inizio = new Date(dataInizio);
      const fine = new Date(dataFine);
  
      // numero totale di giorni tra le due date
      let giorniTotali = Math.round((fine - inizio) / (1000 * 60 * 60 * 24));
  
      // weekend da 0
      let weekend = 0;
  
      // iteriamo
      for (let i = 0; i <= giorniTotali; i++) {
        // data corrente
        const dataCorrente = new Date(inizio);
        dataCorrente.setDate(inizio.getDate() + i);

        // giorno della settimana è sabato o domenica
        if (dataCorrente.getDay() === 6 || dataCorrente.getDay() === 0) {
            weekend++;
        }
      }
  
      return weekend;
    }


    //se festività compresa:
    function isDateBetween(dateToCheck, startDate, endDate) {
      const checkDate2 = new Date(dateToCheck);
      const startDate2 = new Date(startDate);
      const endDate2 = new Date(endDate);

      return checkDate2 >= startDate2 && checkDate2 <= endDate2;
    }


    // quante festività
    function countDatesPresent(dates, startDate, endDate) {
      let dataPresenteNVolte = 0;

      let DendDate = endDate;

      for (const date of dates) {

        let Ddate = new Date(date);

        // il giorno è contenuto nelle festività
        if (isDateBetween(date, startDate, DendDate)) {
            dataPresenteNVolte++;
        }
      
      }

      return dataPresenteNVolte;
    }
    

    // formatta
    function formatDate(dateString) {
      const date = new Date(dateString);
      const options = {
        day: "numeric",
        month: "long"
      };
      return date.toLocaleDateString("it-IT", options);
    }
    
    // inizio calcolo
    let hrs = dataCorrente.getHours();
    let day = dataCorrente.getUTCDay();

    let millisecondsPerHour = 3600000;

    let premerc;
    let pre12;

    let spedDate;

    // è prma delle 12?
    if (hrs < 12) {
      pre12 = true;
    }
    else {
      pre12 = false;
    } 

    // è prima di merc?
    if (day < 3 && day != 0) {
      premerc = true;
    }
    else {
      premerc = false;
    }

    // è sabato o domenica?
    // sabato
    if (dataCorrente.getUTCDay() == 6) { 
      dataCorrente = new Date(dataCorrente.getTime() + (48 * millisecondsPerHour));

      pre12 = true;
      premerc = true;
    }  
    // domenica
    else if (dataCorrente.getUTCDay() == 0) { 
      dataCorrente = new Date(dataCorrente.getTime() + (24 * millisecondsPerHour));

      pre12 = true;
      premerc = true;
    } 

    // se dopo mezzogiorno
    if (pre12 == false) {
      tempbase = tempbase + 24;
    }

    // totale millisecondi
    let totalMilliseconds = tempbase * millisecondsPerHour;
    // data di spedizione senza we e festività
    let ordDate = new Date(dataCorrente.getTime() + totalMilliseconds);

    let uffDate;
    let tempbase2;

    if (premerc == false) {
      uffDate = ordDate.getUTCDay() + 2;
      tempbase2 = tempbase + 48;
    }
    else {
      uffDate = ordDate.getUTCDay();
      tempbase2 = tempbase;
    }


    // mill 1970
    let totalMilliseconds2 = tempbase2 * millisecondsPerHour;
    let prevDate = new Date(dataCorrente.getTime() + totalMilliseconds2);

    // numero date presenti
    const numeroDatePresenti = countDatesPresent(dateArray, dataCorrente, prevDate);

    for (let index = 0; index < numeroDatePresenti; index++) {
      prevDate = new Date(prevDate.getTime() + (24 * millisecondsPerHour)); 
    }
    
    // se sped nel weekend slitta
    // sabato
    if (prevDate.getUTCDay() == 6) { 
      spedDate = new Date(prevDate.getTime() + (48 * millisecondsPerHour)); 
    }
    // domenica
    else if (prevDate.getUTCDay() == 0) { 
      spedDate = new Date(prevDate.getTime() + (24 * millisecondsPerHour)); 
    }
    // altrimenti
    else { 
      spedDate = prevDate;
    }

    for (const date of dateArray) {

      let Ddate = new Date(date);

      if (converter(Ddate) == converter(spedDate)) {
        const data = new Date(spedDate);
        
        //aggiungi un giorno
        spedDate = data.setDate(data.getDate() + 1);
      }
    }

    
    // calcolo weekend
    /*let numeroWeek = calcolaWeekend(new Date(), spedDate);

    let i = 0;

    while (i < numeroWeek) {
      spedDate = spedDate + (48 * millisecondsPerHour);
      i++;
    }
    
    let checkDate = new Date(spedDate);
  
    if (checkDate.getUTCDay() == 6) { 
      spedDate = new Date(checkDate.getTime() + (48 * millisecondsPerHour)); 
    }
    // domenica
    else if (checkDate.getUTCDay() == 0) { 
      spedDate = new Date(checkDate.getTime() + (24 * millisecondsPerHour)); 
    }*/

    // stampa
    const dateString = spedDate;
    const formattedDate = formatDate(dateString);

    function dateCnsInt() {
  
      let elementTarg;
      elementTarg = 0;
        
      elementTarg = document.querySelectorAll(".data-cns");
  
      if (elementTarg.length > 0) {
        for (let i = 0; i < elementTarg.length; i++) {
           
          if (elementTarg[i].innerText == 0 ) {
              elementTarg[i].innerHTML = formattedDate;
          }
        }
      }

    }
    
    // cerca val vuoti ogni 200ms e stampa
    setInterval(dateCnsInt, 200);
    
}


window.addEventListener("DOMContentLoaded", () => {

  dateCns();

});